var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#5FBA99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.121 11.4438L19.0545 9.75873C18.8297 9.49671 18.5216 9.33325 18.1763 9.33325H14.4904C14.145 9.33325 13.8369 9.49671 13.6122 9.75873L12.5457 11.4438C12.3209 11.7062 12.0312 11.8974 11.6859 11.8974H9.28205C8.94203 11.8974 8.61594 12.0324 8.3755 12.2729C8.13507 12.5133 8 12.8394 8 13.1794V20.8717C8 21.2117 8.13507 21.5378 8.3755 21.7783C8.61594 22.0187 8.94203 22.1538 9.28205 22.1538H23.3846C23.7246 22.1538 24.0507 22.0187 24.2912 21.7783C24.5316 21.5378 24.6667 21.2117 24.6667 20.8717V13.1794C24.6667 12.8394 24.5316 12.5133 24.2912 12.2729C24.0507 12.0324 23.7246 11.8974 23.3846 11.8974H21.0208C20.6743 11.8974 20.3458 11.7062 20.121 11.4438Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 19.5897C18.1037 19.5897 19.5387 18.1547 19.5387 16.3846C19.5387 14.6144 18.1037 13.1794 16.3335 13.1794C14.5634 13.1794 13.1284 14.6144 13.1284 16.3846C13.1284 18.1547 14.5634 19.5897 16.3335 19.5897Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.045 11.8172V10.9358H10.0835V11.8172",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.cbe4b7eb7920046c1e12fcf7389a006f.svg";
export { ForwardRef as ReactComponent };